
export const getIsVerified = () => {
  return localStorage.getItem('isVerified') === 'true';
}

export const setIsVerified = (value) => {
  localStorage.setItem('isVerified', String(value));
}

export const setIsEmailRequired = (value) => {
  return localStorage.setItem('isEmailRequired', String(value));
}

export const getIsEmailRequired = () => {
  return localStorage.getItem('isEmailRequired') === 'true';
}

export const setIsPhoneRequired = (value) => {
  localStorage.setItem('isPhoneRequired', String(value));
}

export const getIsPhoneRequired = () => {
  return localStorage.getItem('isPhoneRequired') === 'true';
}


export const getIsFillProfile = () => {
  return localStorage.getItem('isFillProfile') === 'true';
}

export const setIsFillProfile = (value) => {
  localStorage.setItem('isFillProfile', String(value));
}

// Доработка 25. Есть ли подтверждённая медкарта у кого-то из членов семьи
// (HAS_FAMILY_CHART из get_user_data). Хранится рядом с isVerified и по той же причине:
// меню и RequireVerified решают, пускать ли в "Медкарту", до того как придёт ответ
// get_user_data, - без сохранённого значения раздел мигал бы на каждой перезагрузке.
export const getHasFamilyChart = () => {
  return localStorage.getItem('hasFamilyChart') === 'true';
}

export const setHasFamilyChart = (value) => {
  localStorage.setItem('hasFamilyChart', String(value));
}
